import React, { FunctionComponent } from 'react'
import { WbIcon } from '@workbench/react/dist'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'
import { ButtonProps, buttonClass } from './Button'

export const LinkButton: FunctionComponent<ButtonProps & RouterLinkProps> = ({
  size = 'large',
  theme = 'light',
  variant = 'primary',
  className,
  loading,
  icon,
  children,
  ...linkProps
}) => {
  return (
    <RouterLink
      className={buttonClass(variant, size, className)}
      {...linkProps}
    >
      {icon && (
        <WbIcon name={icon} aria-hidden="true" className="wb-button__icon" />
      )}

      {children}
    </RouterLink>
  )
}
